import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { FileText, Calendar, MessageCircle, Send } from 'lucide-react';
import ContactModal from './ContactModal';

/**
 * MobileStickyBar — CTA fixe bas de page sur mobile
 * Réserver · Devis · Contacter (via modale)
 */
export default function MobileStickyBar({ productId = null, quoteId = null }) {
  const [contactOpen, setContactOpen] = useState(false);

  return (
    <>
      {/* STICKY BAR — Mobile only */}
      <div
        className="fixed bottom-0 left-0 right-0 z-50 lg:hidden"
        style={{
          background: 'rgba(255,255,255,0.97)',
          backdropFilter: 'blur(12px)',
          borderTop: '1px solid var(--border)',
          boxShadow: '0 -8px 24px rgba(26,26,46,0.10)',
          paddingBottom: 'env(safe-area-inset-bottom, 0px)',
        }}
      >
        <div className="flex gap-1.5 px-3 py-2.5">
          {/* Réserver */}
          <Link
            to="/creer-evenement"
            className="flex-1 flex flex-col items-center justify-center gap-0.5 py-2.5 rounded-xl"
            style={{ background: 'var(--teal)', color: '#0B1E20' }}
          >
            <Calendar size={16} />
            <span className="text-xs font-bold">Réserver</span>
          </Link>

          {/* Devis */}
          <Link
            to={quoteId ? `/devis/${quoteId}` : '/panier'}
            className="flex-1 flex flex-col items-center justify-center gap-0.5 py-2.5 rounded-xl"
            style={{ background: 'var(--rose-mist)', color: '#B94B5C', border: '1px solid rgba(244,167,178,0.3)' }}
          >
            <FileText size={16} />
            <span className="text-xs font-bold">Devis</span>
          </Link>

          {/* Contacter via le site */}
          <button
            onClick={() => setContactOpen(true)}
            className="flex-1 flex flex-col items-center justify-center gap-0.5 py-2.5 rounded-xl"
            style={{ background: '#0B1E20', color: '#D4AF37', border: 'none', cursor: 'pointer' }}
          >
            <Send size={16} />
            <span className="text-xs font-bold">Message</span>
          </button>
        </div>
      </div>

      {/* Modale contact */}
      <ContactModal
        open={contactOpen}
        onClose={() => setContactOpen(false)}
        sourcePage="Barre mobile"
      />
    </>
  );
}
